
const url = 'https://static.eaydu.com/vod/';
const eayduUrl = 'https://eaydu-video.oss-cn-beijing.aliyuncs.com/'

export default {
   video: [{
      url: `${url}GettyImages-1167423583.mov`
   },
   {
      url: `${url}GettyImages-1198245958.mov`
   },
   {
      url: `${url}GettyImages-1198259163.mov`
   },
   {
      url: `${url}GettyImages-1200671766.mov`
   },
   {
      url: `${url}GettyImages-1206165379.mov`
   },
   {
      url: `${url}GettyImages-1214161610.mov`
   },
   {
      url: `${url}GettyImages-1215338427.mov`
   },
   {
      url: `${url}GettyImages-1216779243.mov`
   },
   {
      url: `${url}GettyImages-1222098358.mov`
   },
   ],
   puzzle: [
      {
         url: `https://static.eaydu.com/docotor/01.mp4`,
         title: '熊猫博士',
         router: '/detail1'
      },
      {
         url: `${eayduUrl}video2/01.mp4`,
         title: '熊猫博士和托托（二）',
         router: '/detail2'
      },
      {
         url: `${eayduUrl}video3/01.mp4`,
         title: '熊猫博士和托托（三）',
         router: '/detail3'
      },
      {
         url: `${eayduUrl}video4/1.mp4`,
         title: '熊猫博士和托托英文版（第一季）',
         router: '/detail4'
      },
      {
         url: `${eayduUrl}video5/1.mov`,
         title: '熊猫博士和托托英文版（第二季）',
         router: '/detail5'
      },
      {
         url: `${eayduUrl}video6/1.mp4`,
         title: '熊猫博士和托托英文版（第三季）',
         router: '/detail6'
      },
      {
         url: `${eayduUrl}video7/1.mp4`,
         title: '熊猫博士看世界：安全消防课',
         router: '/detail7'
      },
      {
         url: `${eayduUrl}video8/1.mp4`,
         title: '熊猫博士看世界：垃圾分类总动员',
         router: '/detail8'
      },
      {
         url: `${eayduUrl}video9/1.mp4`,
         title: '熊猫博士看世界：汽车的小秘密',
         router: '/detail9'
      },
      {
         url: `${eayduUrl}video10/1.mp4`,
         title: '熊猫博士看世界：新冠肺炎全科普',
         router: '/detail0'
      }
   ],
   patriotic: [
      {
         url: `${eayduUrl}earth/1.mp4`,
         title: '跟我一起探索宇宙',
         router: '/patrioticDetail/1'
      }, {
         url: `${eayduUrl}mars/1.mp4`,
         title: '关于火星的小秘密',
         router: '/patrioticDetail/2'
      }, {
         url: `${eayduUrl}country/1.mp4`,
         title: '礼花弹爱国视频',
         router: '/patrioticDetail/3'
      }, {
         url: `${eayduUrl}space/1.mp4`,
         title: '奇妙的航天知识',
         router: '/patrioticDetail/4'
      }, {
         url: `${eayduUrl}country1/1.mp4`,
         title: '强国课堂第一季系列（1）',
         router: '/patrioticDetail/5'
      }, {
         url: `${eayduUrl}country2/1.mp4`,
         title: '强国课堂第一季系列（2）',
         router: '/patrioticDetail/6'
      }, {
         url: `${eayduUrl}country3/1.mp4`,
         title: '强国课堂第一季系列（3）',
         router: '/patrioticDetail/7'
      }, {
         url: `${eayduUrl}sky1/1.mp4`,
         title: '太空请回答1',
         router: '/patrioticDetail/8'
      }, {
         url: `${eayduUrl}sky2/1.mp4`,
         title: '太空请回答2',
         router: '/patrioticDetail/9'
      }, {
         url: `${eayduUrl}story/1.mp4`,
         title: '学而思爱国课堂将军爷爷讲故事',
         router: '/patrioticDetail/10'
      }, {
         url: `${eayduUrl}spaceclass/1.mp4`,
         title: '杨利伟给青少年的航天课',
         router: '/patrioticDetail/11'
      },
   ],
   science: [
      {
         url: `${eayduUrl}math/1.mp4`,
         title: '生活中的数学',
         router: '/scienceDetail/1'
      }, {
         url: `${eayduUrl}magic/1.mp4`,
         title: '玩魔术学科学',
         router: '/scienceDetail/2'
      }, {
         url: `${eayduUrl}game/1.mp4`,
         title: '玩游戏练思维',
         router: '/scienceDetail/3'
      }
   ],
   puzzleRankingList: [
      {
         title: "熊猫博士",
         views: "5230",
         path: "/commonDetail?id=bear",
      },
      {
         title: "小熊优恩",
         views: "4223",
         path: "/commonDetail?id=bear",
      },
      {
         title: "卫浴也疯狂",
         views: "3433",
         path: "/commonDetail?id=bath",
      },
      {
         title: "功夫家族之笨笨鼠",
         views: "2324",
         path: "/commonDetail?id=mouse",
      },
      {
         title: "卡西龙之寻龙记",
         views: "1838",
         path: "/commonDetail?id=dragon",
      },
      {
         title: "石头娃",
         views: "988",
         path: "/commonDetail?id=stone",
      },
      // {
      //    title: "嘟嘟镇",
      //    views: "789",
      //    path: "/commonDetail?id=cities",
      // },
      {
         title: "百越历险记之壮锦密码",
         views: "677",
         path: "/commonDetail?id=code",
      },
      {
         title: "铜鼓奇缘",
         views: "344",
         path: "/commonDetail?id=drum",
      },
      {
         title: "瓷都传奇之牛牛和妞妞",
         views: "213",
         path: "/commonDetail?id=legend1",
      },
   ],
   monkey: [
      {
         url: `${eayduUrl}monkeych/1.mp4`,
         title: '小猴语文',
         router: '/monkeyDetail/1'
      }, {
         url: `${eayduUrl}monkeyai/1.mp4`,
         title: '小猴AI启蒙课',
         router: '/monkeyDetail/2'
      }
   ],
   life: [
      {
         url: `${eayduUrl}life/1.mp4`,
         title: '生活中的科学',
         router: '/lifeDetail/1'
      }
   ],
   youth: [
      {
         url: `${eayduUrl}youth/01.mp4`,
         title: '少年张謇',
         router: '/lifeDetail/1'
      }
   ],
   drum: [
      {
         url: `${eayduUrl}drum/01.mp4`,
         title: '铜鼓奇缘',
         router: '/lifeDetail/1'
      }
   ],
   star: [
      {
         url: `${eayduUrl}star/01.mp4`,
         title: '哈喽！葡星人',
         router: '/lifeDetail/1'
      }
   ],
   star2: [
      {
         url: `${eayduUrl}star2/01.mp4`,
         title: '哈喽！葡星人之极训特工',
         router: '/lifeDetail/1'
      }
   ],
   protected: [
      {
         url: `${eayduUrl}protected/01.mp4`,
         title: '魔能圣甲：守护者',
         router: '/lifeDetail/1'
      }
   ],
   hero: [
      {
         url: `${eayduUrl}hero/01.mp4`,
         title: '么么侠 第一季',
         router: '/lifeDetail/1'
      }
   ],
   yunnan1: [
      {
         url: `${eayduUrl}yunnan1/01.mp4`,
         title: '穿越云南三千年-云小志漫游记',
         router: '/lifeDetail/1'
      }
   ],
   yunnan2: [
      {
         url: `${eayduUrl}yunnan2/01.mp4`,
         title: '穿越云南三千年-云小志漫游记（第二季）',
         router: '/lifeDetail/1'
      }
   ],
   Onepage02: [
      {
         url: `${eayduUrl}Onepage02/01.mp4`,
         title: '翻开这一页第二季',
         router: '/lifeDetail/1'
      }
   ],
   Onepage03: [
      {
         url: `${eayduUrl}Onepage03/01.mp4`,
         title: '翻开这一页第三季',
         router: '/lifeDetail/1'
      }
   ],
   moral01: [
      {
         url: `${eayduUrl}moral01/01.mp4`,
         title: '老子道德三百问（第一季）',
         router: '/lifeDetail/1'
      }
   ],
   moral02: [
      {
         url: `${eayduUrl}moral02/01.mp4`,
         title: '老子道德三百问（第二季）',
         router: 'commonDetail?id=moral02'
      }
   ],
   bus1: [
      {
         url: `${eayduUrl}bus1/01.mp4`,
         title: '阿古顿巴第一季',
         router: 'commonDetail?id=bus1'
      }
   ],
   bus2: [
      {
         url: `${eayduUrl}bus2/01.mp4`,
         title: '阿古顿巴第二季',
         router: 'commonDetail?id=bus2'
      }
   ],
   six: [
      {
         url: `${eayduUrl}six/01.mp4`,
         title: '蔡六',
         router: 'commonDetail?id=six'
      }
   ],
   legend1: [
      {
         url: `${eayduUrl}legend1/01.mp4`,
         title: '瓷都传奇之牛牛和妞妞',
         router: 'commonDetail?id=legend1'
      }
   ],
  //  cities: [
  //     {
  //        url: `${eayduUrl}cities/01.mp4`,
  //        title: '嘟嘟镇',
  //        router: 'commonDetail?id=cities'
  //     }
  //  ],
   mouse: [
      {
         url: `${eayduUrl}mouse/01.mp4`,
         title: '功夫家族之笨笨鼠',
         router: 'commonDetail?id=mouse'
      }
   ],
   dragon: [
      {
         url: `${eayduUrl}dragon/01.mp4`,
         title: '卡西龙之寻龙记',
         router: 'commonDetail?id=dragon'
      }
   ],
   stone: [
      {
         url: `${eayduUrl}stone/01.mp4`,
         title: '石头娃',
         router: 'commonDetail?id=stone'
      }
   ],
   house: [
      {
         url: `${eayduUrl}house/01.mp4`,
         title: '土楼探险之牛牛和妞妞',
         router: 'commonDetail?id=house'
      }
   ],
   bath: [
      {
         url: `${eayduUrl}bath/01.mp4`,
         title: '卫浴也疯狂',
         router: 'commonDetail?id=bath'
      }
   ],
   bear: [
      {
         url: `${eayduUrl}bear/01.mp4`,
         title: '小熊优恩',
         router: 'commonDetail?id=bear'
      }
   ],
   earthCountry: [
      {
         url: `${eayduUrl}earthCountry/01.mp4`,
         title: '探索地球村',
         router: 'commonDetail?id=earthCountry'
      }
   ],
   sweet: [
      {
         url: `${eayduUrl}sweet/01.mp4`,
         title: '甜蜜日记',
         router: 'commonDetail?id=sweet'
      }
   ],
   toy2: [
      {
         url: `${eayduUrl}toy2/01.mp4`,
         title: '托雷的玩具城第二部',
         router: 'commonDetail?id=toy2'
      }
   ],
   toy1: [
      {
         url: `${eayduUrl}toy1/01.mp4`,
         title: '托雷的玩具城第一部',
         router: 'commonDetail?id=toy1'
      }
   ],
   house2: [
      {
         url: `${eayduUrl}house2/01.mp4`,
         title: '玩个玩具之芭比的大房子',
         router: 'commonDetail?id=house2'
      }
   ],
   pig: [
      {
         url: `${eayduUrl}pig/01.mp4`,
         title: '小泼猴与哼哼猪',
         router: 'commonDetail?id=pig'
      }
   ],
   teeth: [
      {
         url: `${eayduUrl}teeth/01.mp4`,
         title: '牙牙精灵战队',
         router: 'commonDetail?id=teeth'
      }
   ],
   workshop: [
      {
         url: `${eayduUrl}workshop/01.mp4`,
         title: '玩个玩具之彩泥霓虹工坊',
         router: 'commonDetail?id=workshop'
      }
   ], 
   machine: [
      {
         url: `${eayduUrl}machine/01.mp4`,
         title: '玩个玩具之迪士尼陶艺机',
         router: 'commonDetail?id=machine'
      }
   ], 
   mokey: [
      {
         url: `${eayduUrl}mokey/01.mp4`,
         title: '玩个玩具之翻斗猴子',
         router: 'commonDetail?id=mokey'
      }
   ], eggs: [
      {
         url: `${eayduUrl}eggs/01.mp4`,
         title: '玩个玩具之疯狂动物城奇趣蛋',
         router: 'commonDetail?id=eggs'
      }
   ], waterbox: [
      {
         url: `${eayduUrl}waterbox/01.mp4`,
         title: '玩个玩具之欢乐水族箱',
         router: 'commonDetail?id=waterbox'
      }
   ], coffee: [
      {
         url: `${eayduUrl}coffee/01.mp4`,
         title: '玩个玩具之欢迎来到兔叽咖啡厅',
         router: 'commonDetail?id=coffee'
      }
   ], strangeegg: [
      {
         url: `${eayduUrl}strangeegg/01.mp4`,
         title: '玩个玩具之佩奇的生日礼物奇趣蛋',
         router: 'commonDetail?id=strangeegg'
      }
   ], playground: [
      {
         url: `${eayduUrl}playground/01.mp4`,
         title: '玩个玩具之星海湾游乐场游记',
         router: 'commonDetail?id=playground'
      }
   ], rabbit: [
      {
         url: `${eayduUrl}rabbit/01.mp4`,
         title: '玩个玩具之一只神奇的兔子',
         router: 'commonDetail?id=rabbit'
      }
   ], penguin: [
      {
         url: `${eayduUrl}penguin/01.mp4`,
         title: '玩个玩具之拯救企鹅',
         router: 'commonDetail?id=penguin'
      }
   ], youngduck: [
      {
         url: `${eayduUrl}youngduck/01.mp4`,
         title: '玩个玩具之抓住那个捣蛋鬼',
         router: 'commonDetail?id=youngduck'
      }
   ], code: [
      {
         url: `${eayduUrl}code/01.mp4`,
         title: '百越历险记之壮锦密码',
         router: 'commonDetail?id=code'
      }
   ], Onepage04: [
      {
         url: `${eayduUrl}Onepage04/01.mp4`,
         title: '翻开这一页第四季',
         router: 'commonDetail?id=Onepage04'
      }
   ], Onepage01: [
      {
         url: `${eayduUrl}Onepage01/01.mp4`,
         title: '翻开这一页第一季',
         router: 'commonDetail?id=Onepage01'
      }
   ], growth: [
      {
         url: `${eayduUrl}growth/01.mp4`,
         title: '嗨，顾得白之快乐成长',
         router: 'commonDetail?id=growth'
      }
   ], precious: [
      {
         url: `${eayduUrl}precious/01.mp4`,
         title: '嗨，顾得白之爱最珍贵',
         router: 'commonDetail?id=precious'
      }
   ], car: [
      {
         url: `${eayduUrl}car/01.mp4`,
         title: '轰轰龙之超级汽车救援队',
         router: 'commonDetail?id=car'
      }
   ], wood: [
      {
         url: `${eayduUrl}wood/01.mp4`,
         title: '吉木故事会',
         router: 'commonDetail?id=wood'
      }
   ], 
  //  Health: [
  //     {
  //        url: `${eayduUrl}Health/01.mp4`,
  //        title: '精灵爱牙讲堂之口腔健康知识',
  //        router: 'commonDetail?id=Health'
  //     }
  //  ], 
  //  happy: [
  //     {
  //        url: `${eayduUrl}happy/01.mp4`,
  //        title: '快乐故事屋',
  //        router: 'commonDetail?id=happy'
  //     }
  //  ], 
  //  tiger: [
  //     {
  //        url: `${eayduUrl}tiger/01.mp4`,
  //        title: '乐乐虎大世界',
  //        router: 'commonDetail?id=tiger'
  //     }
  //  ], 
  //  fruit: [
  //     {
  //        url: `${eayduUrl}fruit/01.mp4`,
  //        title: '萌果乐多多之水果勋章（一）',
  //        router: 'commonDetail?id=fruit'
  //     }
  //  ], 
   farm01: [
      {
         url: `${eayduUrl}farm01/01.mp4`,
         title: '丰丰农场之肥虫豆豆第一部',
         router: 'commonDetail?id=farm01'
      }
   ], farm02: [
      {
         url: `${eayduUrl}farm02/01.mp4`,
         title: '丰丰农场之肥虫豆豆第二部',
         router: 'commonDetail?id=farm02'
      }
   ], legend: [
      {
         url: `${eayduUrl}legend/1.mp4`,
         title: '摩比传说',
         router: 'commonDetail?id=legend'
      }
   ],
}

